import type { ApiClient } from './client.js';
import type { ClassroomDto, CreateClassroomBody, ClassroomStatus } from './types.js';

export interface ClassroomsApi {
  list(status?: ClassroomStatus): Promise<ClassroomDto[]>;
  create(body: CreateClassroomBody): Promise<ClassroomDto>;
  archive(id: string): Promise<ClassroomDto>;
  unarchive(id: string): Promise<ClassroomDto>;
  patch(id: string, body: Partial<CreateClassroomBody>): Promise<ClassroomDto>;
}

export function createClassroomsApi(client: ApiClient): ClassroomsApi {
  return {
    async list(status) {
      const path = status ? `/api/classrooms?status=${status}` : '/api/classrooms';
      const res = await client.get<{ classrooms: ClassroomDto[] }>(path);
      return res.classrooms;
    },
    async create(body) {
      const res = await client.post<{ classroom: ClassroomDto }>('/api/classrooms', body);
      return res.classroom;
    },
    async archive(id) {
      const res = await client.post<{ classroom: ClassroomDto }>(`/api/classrooms/${id}/archive`);
      return res.classroom;
    },
    async unarchive(id) {
      const res = await client.post<{ classroom: ClassroomDto }>(`/api/classrooms/${id}/unarchive`);
      return res.classroom;
    },
    async patch(id, body) {
      const res = await client.patch<{ classroom: ClassroomDto }>(`/api/classrooms/${id}`, body);
      return res.classroom;
    },
  };
}
